import { useDialog } from '../useDialog';
import { useFetchAllCreatedBrollCaptions } from '../../services';
import { FetchBrollCaptionParams } from '../../../t2c-fe/services/broll-caption/fetchBrollCaptionData';
import { BrollCaptionsAndRenderType } from '../../../t2c-fe/utils';

export const useBrollCaption = (params: FetchBrollCaptionParams, model?: BrollCaptionsAndRenderType, onlySuccess?: boolean ) => {
  const {
    isDialogOpen: isCreateBrollCaptionDialogOpen,
    openDialog: openCreateBrollCaptionDialog,
    closeDialog: closeCreateBrollCaptionDialog,
  } = useDialog();

  const {
    data: brollCaptions,
    isLoading: isBrollCaptionsLoading,
    refetch: refetchDataBrollCaptions,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useFetchAllCreatedBrollCaptions(params, model, onlySuccess);

  return {
    isCreateBrollCaptionDialogOpen,
    openCreateBrollCaptionDialog,
    closeCreateBrollCaptionDialog,
    brollCaptions: brollCaptions,
    count: brollCaptions?.pages?.[0]?.videosTotalCount,
    isBrollCaptionsLoading,
    refetchDataBrollCaptions,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  };
};
